
export default {
    // 消息中间件信息查询接口
    queryMqChannelInfo (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/listMqChannelInfo', params, response)
    },
    // 消息中间件删除接口
    deleteMqChannel (params, response) {
        window.vue.$apiAxios.get('/databusserver/interfaceManager/deleteMqChannel', params, response)
    },
    // 消息添加接口
    addMqChannel (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/insertMqChannel', params, response)
    },
    // 消息更新接口
    updateMqChannel (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/updateMqChannel', params, response)
    },
    // 查询所有消息中间件接口
    queryMqInfo (params, response) {
        window.vue.$apiAxios.get('/databusserver//interfaceManager/listAllMqInfo', params, response)
    },
    // 资源查询接口
    queryResourceInfo (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/listResourceInfo', params, response)
    },
    // 查询未被绑定的资源和已被该队列绑定的资源接口
    queryResourceInfoByChannelId (params, response) {
        window.vue.$apiAxios.get('/databusserver/interfaceManager/listResourceInfoByChannelId', params, response)
    },
    // 添加资源和队列关联关系
    addResQueueRelated (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/insertResQueueRelated', params, response)
    },
    // 查询所有队列与资源的关联列表信息，支持分页查询,支持查询全部
    queryRelationsInfo (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/listRelationsInfo', params, response)
    }
}
